import React from "react";
import { Popover as AntdPopover, PopoverProps } from "antd";
import classNames from "classnames";
import { tyPopoverCls } from "./styled";

export const Popover = (props: PopoverProps) => {
  return (
    <AntdPopover
      {...props}
      arrow={false}
      overlayClassName={classNames(tyPopoverCls, props.className)}
    />
  );
};

Object.assign(Popover, AntdPopover);
